import { EnumOption } from './enum-option';

export const ReviewStatus = {
  'Not Started': 0,
  'In Progress': 1,
  'Completed': 2,
  'Report an Issue': 3,
}

export const ReviewStatusList: EnumOption[] = [
  { value: ReviewStatus['Not Started'], label: 'Not Started' },
  { value: ReviewStatus['In Progress'], label: 'In Progress' },
  { value: ReviewStatus['Completed'], label: 'Completed' },
  { value: ReviewStatus['Report an Issue'], label: 'Report an Issue' }
];
